<script setup>

import Button from "@/components/common/input/Button";
import UploadedFileSave from "@/classes/global/UploadedFileSave";

import {ref, computed} from 'vue';
import {useProcessUploadedFiles} from "@/composables/common/useProcessUploadFiles";

const uploadButton = ref();
const uploadFileSizeError = ref();

let uploadFileSizeErrorMessage = ref();

const updateFileInput = computed(() => {

  return props.modelValue.files.length
})

const props = defineProps({

  modelValue: {}
})

function handleUpload() {

  uploadButton.value.click()
}

async function handleUploadedFiles(files) {

  uploadFileSizeError.value = false;

  let fileUploadOk = await useProcessUploadedFiles(files, props.modelValue)

  if (!fileUploadOk.value) {

    uploadFileSizeError.value = true;
    uploadFileSizeErrorMessage.value = fileUploadOk.file.name + ' ' + 'is too large to upload - max 28MB'
  }

}

async function getAsByteArray(file) {

  return new Uint8Array(await readFile(file))
}

function readFile(file) {

  return new Promise((resolve, reject) => {
    // Create file reader
    let reader = new FileReader()

    // Register event listeners
    reader.addEventListener("loadend", e => resolve(e.target.result))
    reader.addEventListener("error", reject)

    // Read file
    reader.readAsArrayBuffer(file)
  })
}

function handleRemoveDocument(index) {

  props.modelValue.files.splice(index, 1);

}

</script>

<template class="cmp-document-upload">
<div class="cmp-document-upload_wrapper">
  <div>
    <input :key="updateFileInput" v-show="false" ref="uploadButton" type="file" accept=".txt,.pdf,.png"
           multiple @change="handleUploadedFiles($event.target.files)"/>
    <Button
        @click="handleUpload"
        type="toolbar"
        text="Select">
    </Button>
    <span style="margin-left: 20px; font-size: 11px;">
    You may add multiple files by using ctrl and click in the file window</span>
  </div>
  <div v-if="uploadFileSizeError" class="cmp-document-upload_file-error-area">
    {{uploadFileSizeErrorMessage}}
  </div>
  <div class="cmp-document-upload_headings">
    <div>Name</div>
  </div>
  <div class="cmp-document-upload_uploaded-files-list">
    <div v-for="(item, index) in props.modelValue.files" class="cmp-document-upload_uploaded-files-items">
      &#128194{{item.fileName}}
      <div @click="handleRemoveDocument(index)">
        <div title="REMOVE" style="font-size: 30px; margin-top: 13px; color: darkred; cursor: pointer">&#735</div>
      </div>
    </div>
    <div v-if="props.modelValue.files.length === 0" class="global-no-data-placeholder"
         style="display: flex; align-items: center; justify-content: center; height: 96px; font-size: 12px;">
      No Current Documents
    </div>
  </div>
</div>

</template>

<style lang="scss" scoped>

.cmp-document-upload {

  &_wrapper {
    position: relative;
    padding:10px;
    background-image: linear-gradient(0deg, #fffbf5, #fff);
  }

  &_headings {
    font-size: 13px;
    margin: 20px 0 0 5px;
    display: grid;
    grid-template-columns: 300px
  }

  &_files {
    margin: 3px 0 0 5px!important;
  }

  &_uploaded-files-list {
    margin-top: 7px;
    padding: 5px;
    width: 500px;
    border: 1px solid var(--border-color);
    height: 130px;
    overflow: auto;
    background: #ffffff;
    border-radius: var(--rounded-corners);
  }

  &_uploaded-files-items {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f5f5f5;
    border-radius: 3px;
    padding: 3px 10px 3px 10px;
    margin-top: 3px;
    border-left: 5px solid #457728;
    height: 16px;
    font-size: 12px;
  }

  &_uploaded-files-items:hover {
    border-left: 5px solid #b13c3c;
  }

  &_file-error-area {
    position: absolute;
    top: 40px;
    left: 105px;
    font-size: 12px;
    color: #b71b1b;
  }
}
</style>
